import $ from "jquery";
import Field from "../field";

const Dropdown = (($) => {
  class Dropdown extends Field {
    setOptions(options) {
      this._input.innerHTML = "";

      const selectedValue = this.getValue();

      // Placeholder
      let placeholder = this.getSetting("placeholder", "Select One...");
      let placeholderOption = document.createElement("option");
      placeholderOption.value = "";
      placeholderOption.innerText = placeholder;
      this._input.appendChild(placeholderOption);

      // Options
      options.forEach((option) => {
        const value = option.value ? option.value : option.label;
        const label = option.label ? option.label : option.value;
        if (value || label) {
          let item = document.createElement("option");
          item.value = value;
          item.innerText = label;
          if (selectedValue == value) {
            item.selected = "selected";
          }
          this._input.appendChild(item);
        }
      });
    }
    render() {
      const self = this;

      let id = this.getForm().getID() + "_field_" + this._field.formFieldID;

      this._element = document.createElement("div");
      this._element.classList.add("ion-form-group");
      this._element.classList.add("ion-form-group-dropdown");

      // Label
      this._label = document.createElement("label");
      this._label.htmlFor = id;
      this._label.innerText = this._field.label;
      this._element.appendChild(this._label);

      // Input
      this._input = document.createElement("select");
      this._input.id = id;
      this._input.classList.add("ion-form-control");
      this._input.name = this._field.name;
      this._input.ariaLabel = this._field.label;
      this._input.required = isRequired == 1;
      this._element.appendChild(this._input);

      let isRequired = this.getSetting("isRequired", false);
      if (isRequired == "1") {
        this._element.classList.add("ion-is-required");
        this._input.ariaRequired = true;
      }

      // Default Value
      const selectedValue = this.getValue();

      this.setOptions(this.getSetting("options", []));
      //   // Placeholder
      //   let placeholder = this.getSetting("placeholder", "Select One...");
      //   let placeholderOption = document.createElement("option");
      //   placeholderOption.value = "";
      //   placeholderOption.innerText = placeholder;
      //   this._input.appendChild(placeholderOption);

      //   // Options
      //   let options = this.getSetting("options", []);
      //   options.forEach((option) => {
      //     const value = option.value ? option.value : option.label;
      //     const label = option.label ? option.label : option.value;
      //     if (value || label) {
      //       let item = document.createElement("option");
      //       item.value = value;
      //       item.innerText = label;
      //       if (selectedValue == value) {
      //         item.selected = "selected";
      //       }
      //       this._input.appendChild(item);
      //     }
      //   });

      // Instructions
      let instructions = this._renderInstructions();
      if (instructions) {
        this._element.appendChild(instructions);
      }

      // Messages
      this._renderMessages();
      if (this._messages) {
        this._element.appendChild(this._messages);
      }
    }
  }

  return Dropdown;
})($);

export default Dropdown;
